<div class="cta-section">
  <div class="cta-shell">

    <!-- Left: Testimonial card -->
    <div class="cta-testimonial">
      <span class="cta-quote-mark">&#8220;</span>
      <p class="cta-quote-text">
        Managing 200+ employees used to take our HR team an entire week.
        With orderYaa HR, we close payroll in a single afternoon — and our
        staff actually enjoy using it.
      </p>
      <div class="cta-author">
        <div class="cta-author-avatar">SA</div>
        <div class="cta-author-info">
          <span class="cta-author-name">Sara Ahmed</span>
          <span class="cta-author-role">HR Director, TechFlow Solutions</span>
        </div>
      </div>
    </div>

    <!-- Right: CTA -->
    <div class="cta-content">
      <div class="cta-burst" aria-hidden="true">
        <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="100" y1="10"  x2="100" y2="40"  stroke="#f5c518" stroke-width="3.5" stroke-linecap="round"/>
          <line x1="100" y1="160" x2="100" y2="190" stroke="#f5c518" stroke-width="3.5" stroke-linecap="round"/>
          <line x1="10"  y1="100" x2="40"  y2="100" stroke="#f5c518" stroke-width="3.5" stroke-linecap="round"/>
          <line x1="160" y1="100" x2="190" y2="100" stroke="#f5c518" stroke-width="3.5" stroke-linecap="round"/>
          <line x1="29"  y1="29"  x2="50"  y2="50"  stroke="#f5c518" stroke-width="3.5" stroke-linecap="round"/>
          <line x1="150" y1="50"  x2="171" y2="29"  stroke="#f5c518" stroke-width="3.5" stroke-linecap="round"/>
          <line x1="29"  y1="171" x2="50"  y2="150" stroke="#f5c518" stroke-width="3.5" stroke-linecap="round"/>
          <line x1="150" y1="150" x2="171" y2="171" stroke="#f5c518" stroke-width="3.5" stroke-linecap="round"/>
          <line x1="65"  y1="14"  x2="70"  y2="38"  stroke="#f5c518" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="135" y1="14"  x2="130" y2="38"  stroke="#f5c518" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="14"  y1="65"  x2="38"  y2="70"  stroke="#f5c518" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="14"  y1="135" x2="38"  y2="130" stroke="#f5c518" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="162" y1="65"  x2="186" y2="70"  stroke="#f5c518" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="162" y1="135" x2="186" y2="130" stroke="#f5c518" stroke-width="2.5" stroke-linecap="round"/>
        </svg>
      </div>

      <h2 class="cta-heading">
        <span class="cta-heading--dark">Empower</span><br />
        <span class="cta-heading--teal">your HR team</span>
      </h2>

      <a routerLink="/product" class="cta-btn">Get started — it's free</a>
    </div>

  </div>
</div>
